import { User } from 'lucide-react'

export interface ProviderPreviewCardProps {
  name: string
  credentialsDisplay: string
  bio: string
  avatarUrl?: string | null
}

export function ProviderPreviewCard({
  name,
  credentialsDisplay,
  bio,
  avatarUrl,
}: ProviderPreviewCardProps) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-5">
      <div className="flex items-start gap-4">
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt=""
            className="h-16 w-16 shrink-0 rounded-full object-cover"
          />
        ) : (
          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-slate-100">
            <User className="h-8 w-8 text-slate-400" aria-hidden />
          </div>
        )}
        <div className="min-w-0 flex-1 space-y-1">
          <p className="text-base font-semibold text-slate-900">{name || 'Your name'}</p>
          {credentialsDisplay && (
            <p className="text-sm text-slate-600">{credentialsDisplay}</p>
          )}
          {bio && <p className="text-sm text-slate-700">{bio}</p>}
        </div>
      </div>
    </div>
  )
}
